import { useSyncExternalStore } from 'react'
import {
  isReadonlyFallbackActive,
  getReadonlyReason,
  subscribeReadonlyMode,
  type ReadonlyReason,
} from '../store/readonlyMode'
import { isElectricAvailable, onElectricStatusChange } from '../store/collections'

/**
 * 离线只读模式订阅 hook（TipTapEditor editable / 写入口禁用 / 横幅 共用）
 * 返回 true = 只读模式激活（自动/手动进入；云端对齐后自动退出）
 */
export function useReadonlyFallback(): boolean {
  return useSyncExternalStore(
    subscribeReadonlyMode,
    isReadonlyFallbackActive,
    () => false // SSR/水合期恒 false
  )
}

/** 只读原因（横幅四态文案区分用） */
export function useReadonlyReason(): ReadonlyReason | null {
  return useSyncExternalStore(
    subscribeReadonlyMode,
    getReadonlyReason,
    () => null
  )
}

/** Electric 数据服务可用性订阅（横幅"恢复中/重连中"过渡态判定用） */
export function useElectricAvailable(): boolean {
  return useSyncExternalStore(
    (cb) => onElectricStatusChange(cb),
    isElectricAvailable,
    () => true
  )
}
